// extracted by extract-css-chunks-webpack-plugin
module.exports = {"popover":"popover___tDOfk","icon":"icon___OqFVX"};